export default __webpack_public_path__ + "static/media/chart4.8160af6e.png";